/*
 * Initialize 
 * Initialize various libraries within the framework
 * MIT License
 */
(function($) {

  $('.carousel').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: true,
    instructionsText: 'Changing this current slide of this carousel will change the current slide of the thumbnail carousel that follows.',
    regionLabel: 'Main image carousel',
    speed: 500,
    fade: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

})(jQuery);